import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useRefs } from "@/lib/useRefs";
import { PageHeader } from "@/components/Common";
import AdminEscalations from "@/pages/admin/AdminEscalations";

export default function ConsoleSupport() {
  const { user } = useAuth();
  const refs = useRefs();
  return (
    <div>
      <PageHeader
        eyebrow="Console · Support Contacts"
        title="Support Contacts"
        subtitle={user?.is_admin
          ? "Escalation contacts and SLAs across every program."
          : "Escalation contacts and SLAs for your programs (read-only — ask an administrator to change these)."}
        testid="console-support-header" />
      <AdminEscalations refs={refs} canEdit={!!user?.is_admin} />
    </div>
  );
}
